module.exports = __webpack_public_path__ + "static/media/certificate-placeholder.e6108fc1.png";